// Auth Types
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const LOGOUT = 'LOGOUT';

// Permission Types
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const CLEAR_PERMISSIONS = 'CLEAR_PERMISSIONS';

// Password Management Types
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

// Email Verification Types
export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE';

export const RESEND_VERIFICATION_REQUEST = 'RESEND_VERIFICATION_REQUEST';
export const RESEND_VERIFICATION_SUCCESS = 'RESEND_VERIFICATION_SUCCESS';
export const RESEND_VERIFICATION_FAILURE = 'RESEND_VERIFICATION_FAILURE';

// User Profile Types
export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE';

export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';

// Purchase Order Types
export const FETCH_ORDERS_REQUEST = 'FETCH_ORDERS_REQUEST';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAILURE = 'FETCH_ORDERS_FAILURE';

export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';

export const UPDATE_ORDER_REQUEST = 'UPDATE_ORDER_REQUEST';
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS';
export const UPDATE_ORDER_FAILURE = 'UPDATE_ORDER_FAILURE';


// UI Types
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';

// Vendor Types
export const FETCH_VENDORS_REQUEST = 'FETCH_VENDORS_REQUEST';
export const FETCH_VENDORS_SUCCESS = 'FETCH_VENDORS_SUCCESS';
export const FETCH_VENDORS_FAILURE = 'FETCH_VENDORS_FAILURE';

export const CREATE_VENDOR_REQUEST = 'CREATE_VENDOR_REQUEST';
export const CREATE_VENDOR_SUCCESS = 'CREATE_VENDOR_SUCCESS';
export const CREATE_VENDOR_FAILURE = 'CREATE_VENDOR_FAILURE';

export const UPDATE_VENDOR_REQUEST = 'UPDATE_VENDOR_REQUEST';
export const UPDATE_VENDOR_SUCCESS = 'UPDATE_VENDOR_SUCCESS';
export const UPDATE_VENDOR_FAILURE = 'UPDATE_VENDOR_FAILURE';

export const FETCH_VENDOR_REQUEST = 'FETCH_VENDOR_REQUEST';
export const FETCH_VENDOR_SUCCESS = 'FETCH_VENDOR_SUCCESS';
export const FETCH_VENDOR_FAILURE = 'FETCH_VENDOR_FAILURE';


// Product Types
export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';

export const CREATE_PRODUCT_REQUEST = 'CREATE_PRODUCT_REQUEST';
export const CREATE_PRODUCT_SUCCESS = 'CREATE_PRODUCT_SUCCESS';
export const CREATE_PRODUCT_FAILURE = 'CREATE_PRODUCT_FAILURE';

export const UPDATE_PRODUCT_REQUEST = 'UPDATE_PRODUCT_REQUEST';
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE';

export const GET_PRODUCT_REQUEST = 'GET_PRODUCT_REQUEST';
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const GET_PRODUCT_FAILURE = 'GET_PRODUCT_FAILURE';

// Product Form Data Types
export const FETCH_PRODUCT_FORM_DATA_REQUEST = 'FETCH_PRODUCT_FORM_DATA_REQUEST';
export const FETCH_PRODUCT_FORM_DATA_SUCCESS = 'FETCH_PRODUCT_FORM_DATA_SUCCESS';
export const FETCH_PRODUCT_FORM_DATA_FAILURE = 'FETCH_PRODUCT_FORM_DATA_FAILURE';


// Audit Log Types
export const FETCH_AUDIT_LOGS_REQUEST = 'FETCH_AUDIT_LOGS_REQUEST';
export const FETCH_AUDIT_LOGS_SUCCESS = 'FETCH_AUDIT_LOGS_SUCCESS';
export const FETCH_AUDIT_LOGS_FAILURE = 'FETCH_AUDIT_LOGS_FAILURE';

export const FETCH_AUDIT_LOG_REQUEST = 'FETCH_AUDIT_LOG_REQUEST';
export const FETCH_AUDIT_LOG_SUCCESS = 'FETCH_AUDIT_LOG_SUCCESS';
export const FETCH_AUDIT_LOG_FAILURE = 'FETCH_AUDIT_LOG_FAILURE';

export const FETCH_AUDIT_SUMMARY_REQUEST = 'FETCH_AUDIT_SUMMARY_REQUEST';
export const FETCH_AUDIT_SUMMARY_SUCCESS = 'FETCH_AUDIT_SUMMARY_SUCCESS';
export const FETCH_AUDIT_SUMMARY_FAILURE = 'FETCH_AUDIT_SUMMARY_FAILURE';


export const SET_AUDIT_FILTERS = 'SET_AUDIT_FILTERS';
export const CLEAR_AUDIT_FILTERS = 'CLEAR_AUDIT_FILTERS';
export const SET_AUDIT_PAGINATION = 'SET_AUDIT_PAGINATION';

// Home API Types
export const FETCH_HOME_DATA_REQUEST = 'FETCH_HOME_DATA_REQUEST';
export const FETCH_HOME_DATA_SUCCESS = 'FETCH_HOME_DATA_SUCCESS';
export const FETCH_HOME_DATA_FAILURE = 'FETCH_HOME_DATA_FAILURE';

// Delivery Address Types
export const FETCH_DELIVERY_ADDRESSES_REQUEST = 'FETCH_DELIVERY_ADDRESSES_REQUEST';
export const FETCH_DELIVERY_ADDRESSES_SUCCESS = 'FETCH_DELIVERY_ADDRESSES_SUCCESS';
export const FETCH_DELIVERY_ADDRESSES_FAILURE = 'FETCH_DELIVERY_ADDRESSES_FAILURE';

export const CREATE_DELIVERY_ADDRESS_REQUEST = 'CREATE_DELIVERY_ADDRESS_REQUEST';
export const CREATE_DELIVERY_ADDRESS_SUCCESS = 'CREATE_DELIVERY_ADDRESS_SUCCESS';
export const CREATE_DELIVERY_ADDRESS_FAILURE = 'CREATE_DELIVERY_ADDRESS_FAILURE';

export const UPDATE_DELIVERY_ADDRESS_REQUEST = 'UPDATE_DELIVERY_ADDRESS_REQUEST';
export const UPDATE_DELIVERY_ADDRESS_SUCCESS = 'UPDATE_DELIVERY_ADDRESS_SUCCESS';
export const UPDATE_DELIVERY_ADDRESS_FAILURE = 'UPDATE_DELIVERY_ADDRESS_FAILURE';


export const SET_DELIVERY_ADDRESS_EDITING = 'SET_DELIVERY_ADDRESS_EDITING';
export const CLEAR_DELIVERY_ADDRESS_EDITING = 'CLEAR_DELIVERY_ADDRESS_EDITING';

// Udhyam Category Types
export const FETCH_UDHYAM_CATEGORIES_REQUEST = 'FETCH_UDHYAM_CATEGORIES_REQUEST';
export const FETCH_UDHYAM_CATEGORIES_SUCCESS = 'FETCH_UDHYAM_CATEGORIES_SUCCESS';
export const FETCH_UDHYAM_CATEGORIES_FAILURE = 'FETCH_UDHYAM_CATEGORIES_FAILURE';

export const FETCH_ACTIVE_UDHYAM_CATEGORIES_REQUEST = 'FETCH_ACTIVE_UDHYAM_CATEGORIES_REQUEST';
export const FETCH_ACTIVE_UDHYAM_CATEGORIES_SUCCESS = 'FETCH_ACTIVE_UDHYAM_CATEGORIES_SUCCESS';
export const FETCH_ACTIVE_UDHYAM_CATEGORIES_FAILURE = 'FETCH_ACTIVE_UDHYAM_CATEGORIES_FAILURE';

export const GET_UDHYAM_CATEGORY_REQUEST = 'GET_UDHYAM_CATEGORY_REQUEST';
export const GET_UDHYAM_CATEGORY_SUCCESS = 'GET_UDHYAM_CATEGORY_SUCCESS';
export const GET_UDHYAM_CATEGORY_FAILURE = 'GET_UDHYAM_CATEGORY_FAILURE';

export const CREATE_UDHYAM_CATEGORY_REQUEST = 'CREATE_UDHYAM_CATEGORY_REQUEST';
export const CREATE_UDHYAM_CATEGORY_SUCCESS = 'CREATE_UDHYAM_CATEGORY_SUCCESS';
export const CREATE_UDHYAM_CATEGORY_FAILURE = 'CREATE_UDHYAM_CATEGORY_FAILURE';

export const UPDATE_UDHYAM_CATEGORY_REQUEST = 'UPDATE_UDHYAM_CATEGORY_REQUEST';
export const UPDATE_UDHYAM_CATEGORY_SUCCESS = 'UPDATE_UDHYAM_CATEGORY_SUCCESS';
export const UPDATE_UDHYAM_CATEGORY_FAILURE = 'UPDATE_UDHYAM_CATEGORY_FAILURE';

export const SET_UDHYAM_CATEGORY_EDITING = 'SET_UDHYAM_CATEGORY_EDITING';
export const CLEAR_UDHYAM_CATEGORY_EDITING = 'CLEAR_UDHYAM_CATEGORY_EDITING';

// Product Category Types
export const FETCH_PRODUCT_CATEGORIES_REQUEST = 'FETCH_PRODUCT_CATEGORIES_REQUEST';
export const FETCH_PRODUCT_CATEGORIES_SUCCESS = 'FETCH_PRODUCT_CATEGORIES_SUCCESS';
export const FETCH_PRODUCT_CATEGORIES_FAILURE = 'FETCH_PRODUCT_CATEGORIES_FAILURE';

export const FETCH_ACTIVE_PRODUCT_CATEGORIES_REQUEST = 'FETCH_ACTIVE_PRODUCT_CATEGORIES_REQUEST';
export const FETCH_ACTIVE_PRODUCT_CATEGORIES_SUCCESS = 'FETCH_ACTIVE_PRODUCT_CATEGORIES_SUCCESS';
export const FETCH_ACTIVE_PRODUCT_CATEGORIES_FAILURE = 'FETCH_ACTIVE_PRODUCT_CATEGORIES_FAILURE';

export const GET_PRODUCT_CATEGORY_REQUEST = 'GET_PRODUCT_CATEGORY_REQUEST';
export const GET_PRODUCT_CATEGORY_SUCCESS = 'GET_PRODUCT_CATEGORY_SUCCESS';
export const GET_PRODUCT_CATEGORY_FAILURE = 'GET_PRODUCT_CATEGORY_FAILURE';

export const CREATE_PRODUCT_CATEGORY_REQUEST = 'CREATE_PRODUCT_CATEGORY_REQUEST';
export const CREATE_PRODUCT_CATEGORY_SUCCESS = 'CREATE_PRODUCT_CATEGORY_SUCCESS';
export const CREATE_PRODUCT_CATEGORY_FAILURE = 'CREATE_PRODUCT_CATEGORY_FAILURE';

export const UPDATE_PRODUCT_CATEGORY_REQUEST = 'UPDATE_PRODUCT_CATEGORY_REQUEST';
export const UPDATE_PRODUCT_CATEGORY_SUCCESS = 'UPDATE_PRODUCT_CATEGORY_SUCCESS';
export const UPDATE_PRODUCT_CATEGORY_FAILURE = 'UPDATE_PRODUCT_CATEGORY_FAILURE';

export const SET_PRODUCT_CATEGORY_EDITING = 'SET_PRODUCT_CATEGORY_EDITING';
export const CLEAR_PRODUCT_CATEGORY_EDITING = 'CLEAR_PRODUCT_CATEGORY_EDITING';

// Firm Name Types
export const FETCH_FIRM_NAMES_REQUEST = 'FETCH_FIRM_NAMES_REQUEST';
export const FETCH_FIRM_NAMES_SUCCESS = 'FETCH_FIRM_NAMES_SUCCESS';
export const FETCH_FIRM_NAMES_FAILURE = 'FETCH_FIRM_NAMES_FAILURE';

export const FETCH_ACTIVE_FIRM_NAMES_REQUEST = 'FETCH_ACTIVE_FIRM_NAMES_REQUEST';
export const FETCH_ACTIVE_FIRM_NAMES_SUCCESS = 'FETCH_ACTIVE_FIRM_NAMES_SUCCESS';
export const FETCH_ACTIVE_FIRM_NAMES_FAILURE = 'FETCH_ACTIVE_FIRM_NAMES_FAILURE';

export const GET_FIRM_NAME_REQUEST = 'GET_FIRM_NAME_REQUEST';
export const GET_FIRM_NAME_SUCCESS = 'GET_FIRM_NAME_SUCCESS';
export const GET_FIRM_NAME_FAILURE = 'GET_FIRM_NAME_FAILURE';

export const CREATE_FIRM_NAME_REQUEST = 'CREATE_FIRM_NAME_REQUEST';
export const CREATE_FIRM_NAME_SUCCESS = 'CREATE_FIRM_NAME_SUCCESS';
export const CREATE_FIRM_NAME_FAILURE = 'CREATE_FIRM_NAME_FAILURE';

export const UPDATE_FIRM_NAME_REQUEST = 'UPDATE_FIRM_NAME_REQUEST';
export const UPDATE_FIRM_NAME_SUCCESS = 'UPDATE_FIRM_NAME_SUCCESS';
export const UPDATE_FIRM_NAME_FAILURE = 'UPDATE_FIRM_NAME_FAILURE';

export const SET_FIRM_NAME_EDITING = 'SET_FIRM_NAME_EDITING';
export const CLEAR_FIRM_NAME_EDITING = 'CLEAR_FIRM_NAME_EDITING';

// RBAC Types
export const FETCH_RBAC_ROLES_REQUEST = 'FETCH_RBAC_ROLES_REQUEST';
export const FETCH_RBAC_ROLES_SUCCESS = 'FETCH_RBAC_ROLES_SUCCESS';
export const FETCH_RBAC_ROLES_FAILURE = 'FETCH_RBAC_ROLES_FAILURE';

export const GET_RBAC_ROLE_REQUEST = 'GET_RBAC_ROLE_REQUEST';
export const GET_RBAC_ROLE_SUCCESS = 'GET_RBAC_ROLE_SUCCESS';
export const GET_RBAC_ROLE_FAILURE = 'GET_RBAC_ROLE_FAILURE';

export const CREATE_RBAC_ROLE_REQUEST = 'CREATE_RBAC_ROLE_REQUEST';
export const CREATE_RBAC_ROLE_SUCCESS = 'CREATE_RBAC_ROLE_SUCCESS';
export const CREATE_RBAC_ROLE_FAILURE = 'CREATE_RBAC_ROLE_FAILURE';

export const UPDATE_RBAC_ROLE_REQUEST = 'UPDATE_RBAC_ROLE_REQUEST';
export const UPDATE_RBAC_ROLE_SUCCESS = 'UPDATE_RBAC_ROLE_SUCCESS';
export const UPDATE_RBAC_ROLE_FAILURE = 'UPDATE_RBAC_ROLE_FAILURE';

export const DELETE_RBAC_ROLE_REQUEST = 'DELETE_RBAC_ROLE_REQUEST';
export const DELETE_RBAC_ROLE_SUCCESS = 'DELETE_RBAC_ROLE_SUCCESS';
export const DELETE_RBAC_ROLE_FAILURE = 'DELETE_RBAC_ROLE_FAILURE';

export const FETCH_ROLE_USERS_REQUEST = 'FETCH_ROLE_USERS_REQUEST';
export const FETCH_ROLE_USERS_SUCCESS = 'FETCH_ROLE_USERS_SUCCESS';
export const FETCH_ROLE_USERS_FAILURE = 'FETCH_ROLE_USERS_FAILURE';

export const FETCH_RBAC_ACTIONS_REQUEST = 'FETCH_RBAC_ACTIONS_REQUEST';
export const FETCH_RBAC_ACTIONS_SUCCESS = 'FETCH_RBAC_ACTIONS_SUCCESS';
export const FETCH_RBAC_ACTIONS_FAILURE = 'FETCH_RBAC_ACTIONS_FAILURE';

export const FETCH_ACTIONS_GROUPED_REQUEST = 'FETCH_ACTIONS_GROUPED_REQUEST';
export const FETCH_ACTIONS_GROUPED_SUCCESS = 'FETCH_ACTIONS_GROUPED_SUCCESS';
export const FETCH_ACTIONS_GROUPED_FAILURE = 'FETCH_ACTIONS_GROUPED_FAILURE';

export const CREATE_RBAC_ACTION_REQUEST = 'CREATE_RBAC_ACTION_REQUEST';
export const CREATE_RBAC_ACTION_SUCCESS = 'CREATE_RBAC_ACTION_SUCCESS';
export const CREATE_RBAC_ACTION_FAILURE = 'CREATE_RBAC_ACTION_FAILURE';

export const UPDATE_RBAC_ACTION_REQUEST = 'UPDATE_RBAC_ACTION_REQUEST';
export const UPDATE_RBAC_ACTION_SUCCESS = 'UPDATE_RBAC_ACTION_SUCCESS';
export const UPDATE_RBAC_ACTION_FAILURE = 'UPDATE_RBAC_ACTION_FAILURE';

export const DELETE_RBAC_ACTION_REQUEST = 'DELETE_RBAC_ACTION_REQUEST';
export const DELETE_RBAC_ACTION_SUCCESS = 'DELETE_RBAC_ACTION_SUCCESS';
export const DELETE_RBAC_ACTION_FAILURE = 'DELETE_RBAC_ACTION_FAILURE';

export const FETCH_ROLE_PERMISSIONS_REQUEST = 'FETCH_ROLE_PERMISSIONS_REQUEST';
export const FETCH_ROLE_PERMISSIONS_SUCCESS = 'FETCH_ROLE_PERMISSIONS_SUCCESS';
export const FETCH_ROLE_PERMISSIONS_FAILURE = 'FETCH_ROLE_PERMISSIONS_FAILURE';

export const BULK_ASSIGN_PERMISSIONS_REQUEST = 'BULK_ASSIGN_PERMISSIONS_REQUEST';
export const BULK_ASSIGN_PERMISSIONS_SUCCESS = 'BULK_ASSIGN_PERMISSIONS_SUCCESS';
export const BULK_ASSIGN_PERMISSIONS_FAILURE = 'BULK_ASSIGN_PERMISSIONS_FAILURE';

export const TOGGLE_PERMISSION_REQUEST = 'TOGGLE_PERMISSION_REQUEST';
export const TOGGLE_PERMISSION_SUCCESS = 'TOGGLE_PERMISSION_SUCCESS';
export const TOGGLE_PERMISSION_FAILURE = 'TOGGLE_PERMISSION_FAILURE';

export const FETCH_RBAC_USERS_REQUEST = 'FETCH_RBAC_USERS_REQUEST';
export const FETCH_RBAC_USERS_SUCCESS = 'FETCH_RBAC_USERS_SUCCESS';
export const FETCH_RBAC_USERS_FAILURE = 'FETCH_RBAC_USERS_FAILURE';

export const GET_RBAC_USER_REQUEST = 'GET_RBAC_USER_REQUEST';
export const GET_RBAC_USER_SUCCESS = 'GET_RBAC_USER_SUCCESS';
export const GET_RBAC_USER_FAILURE = 'GET_RBAC_USER_FAILURE';

export const UPDATE_USER_ROLE_REQUEST = 'UPDATE_USER_ROLE_REQUEST';
export const UPDATE_USER_ROLE_SUCCESS = 'UPDATE_USER_ROLE_SUCCESS';
export const UPDATE_USER_ROLE_FAILURE = 'UPDATE_USER_ROLE_FAILURE';

export const REMOVE_USER_ROLE_REQUEST = 'REMOVE_USER_ROLE_REQUEST';
export const REMOVE_USER_ROLE_SUCCESS = 'REMOVE_USER_ROLE_SUCCESS';
export const REMOVE_USER_ROLE_FAILURE = 'REMOVE_USER_ROLE_FAILURE';

export const SET_RBAC_EDITING = 'SET_RBAC_EDITING';
export const CLEAR_RBAC_EDITING = 'CLEAR_RBAC_EDITING';

// Delivery Challan Types
export const FETCH_DELIVERY_CHALLANS_REQUEST = 'FETCH_DELIVERY_CHALLANS_REQUEST';
export const FETCH_DELIVERY_CHALLANS_SUCCESS = 'FETCH_DELIVERY_CHALLANS_SUCCESS';
export const FETCH_DELIVERY_CHALLANS_FAILURE = 'FETCH_DELIVERY_CHALLANS_FAILURE';

export const FETCH_DELIVERY_CHALLAN_REQUEST = 'FETCH_DELIVERY_CHALLAN_REQUEST';
export const FETCH_DELIVERY_CHALLAN_SUCCESS = 'FETCH_DELIVERY_CHALLAN_SUCCESS';
export const FETCH_DELIVERY_CHALLAN_FAILURE = 'FETCH_DELIVERY_CHALLAN_FAILURE';

export const CREATE_DELIVERY_CHALLAN_REQUEST = 'CREATE_DELIVERY_CHALLAN_REQUEST';
export const CREATE_DELIVERY_CHALLAN_SUCCESS = 'CREATE_DELIVERY_CHALLAN_SUCCESS';
export const CREATE_DELIVERY_CHALLAN_FAILURE = 'CREATE_DELIVERY_CHALLAN_FAILURE';

export const UPDATE_DELIVERY_CHALLAN_REQUEST = 'UPDATE_DELIVERY_CHALLAN_REQUEST';
export const UPDATE_DELIVERY_CHALLAN_SUCCESS = 'UPDATE_DELIVERY_CHALLAN_SUCCESS';
export const UPDATE_DELIVERY_CHALLAN_FAILURE = 'UPDATE_DELIVERY_CHALLAN_FAILURE';

export const VERIFY_DELIVERY_CHALLAN_REQUEST = 'VERIFY_DELIVERY_CHALLAN_REQUEST';
export const VERIFY_DELIVERY_CHALLAN_SUCCESS = 'VERIFY_DELIVERY_CHALLAN_SUCCESS';
export const VERIFY_DELIVERY_CHALLAN_FAILURE = 'VERIFY_DELIVERY_CHALLAN_FAILURE';

export const DELETE_DELIVERY_CHALLAN_REQUEST = 'DELETE_DELIVERY_CHALLAN_REQUEST';
export const DELETE_DELIVERY_CHALLAN_SUCCESS = 'DELETE_DELIVERY_CHALLAN_SUCCESS';
export const DELETE_DELIVERY_CHALLAN_FAILURE = 'DELETE_DELIVERY_CHALLAN_FAILURE';

export const FETCH_PO_DELIVERY_STATUS_REQUEST = 'FETCH_PO_DELIVERY_STATUS_REQUEST';
export const FETCH_PO_DELIVERY_STATUS_SUCCESS = 'FETCH_PO_DELIVERY_STATUS_SUCCESS';
export const FETCH_PO_DELIVERY_STATUS_FAILURE = 'FETCH_PO_DELIVERY_STATUS_FAILURE';

export const FETCH_DELIVERY_STATUS_SUMMARY_REQUEST = 'FETCH_DELIVERY_STATUS_SUMMARY_REQUEST';
export const FETCH_DELIVERY_STATUS_SUMMARY_SUCCESS = 'FETCH_DELIVERY_STATUS_SUMMARY_SUCCESS';
export const FETCH_DELIVERY_STATUS_SUMMARY_FAILURE = 'FETCH_DELIVERY_STATUS_SUMMARY_FAILURE';

export const FETCH_DELIVERY_STATISTICS_REQUEST = 'FETCH_DELIVERY_STATISTICS_REQUEST';
export const FETCH_DELIVERY_STATISTICS_SUCCESS = 'FETCH_DELIVERY_STATISTICS_SUCCESS';
export const FETCH_DELIVERY_STATISTICS_FAILURE = 'FETCH_DELIVERY_STATISTICS_FAILURE';

export const FETCH_PO_CHALLANS_REQUEST = 'FETCH_PO_CHALLANS_REQUEST';
export const FETCH_PO_CHALLANS_SUCCESS = 'FETCH_PO_CHALLANS_SUCCESS';
export const FETCH_PO_CHALLANS_FAILURE = 'FETCH_PO_CHALLANS_FAILURE';

export const SET_DELIVERY_CHALLAN_EDITING = 'SET_DELIVERY_CHALLAN_EDITING';
export const CLEAR_DELIVERY_CHALLAN_EDITING = 'CLEAR_DELIVERY_CHALLAN_EDITING';

// Bill Receipt Types
export const FETCH_BILLS_REQUEST = 'FETCH_BILLS_REQUEST';
export const FETCH_BILLS_SUCCESS = 'FETCH_BILLS_SUCCESS';
export const FETCH_BILLS_FAILURE = 'FETCH_BILLS_FAILURE';

export const FETCH_BILL_REQUEST = 'FETCH_BILL_REQUEST';
export const FETCH_BILL_SUCCESS = 'FETCH_BILL_SUCCESS';
export const FETCH_BILL_FAILURE = 'FETCH_BILL_FAILURE';

export const RECEIVE_BILL_REQUEST = 'RECEIVE_BILL_REQUEST';
export const RECEIVE_BILL_SUCCESS = 'RECEIVE_BILL_SUCCESS';
export const RECEIVE_BILL_FAILURE = 'RECEIVE_BILL_FAILURE';

export const VERIFY_BILL_REQUEST = 'VERIFY_BILL_REQUEST';
export const VERIFY_BILL_SUCCESS = 'VERIFY_BILL_SUCCESS';
export const VERIFY_BILL_FAILURE = 'VERIFY_BILL_FAILURE';

export const REJECT_BILL_REQUEST = 'REJECT_BILL_REQUEST';
export const REJECT_BILL_SUCCESS = 'REJECT_BILL_SUCCESS';
export const REJECT_BILL_FAILURE = 'REJECT_BILL_FAILURE';

export const CLOSE_BILL_REQUEST = 'CLOSE_BILL_REQUEST';
export const CLOSE_BILL_SUCCESS = 'CLOSE_BILL_SUCCESS';
export const CLOSE_BILL_FAILURE = 'CLOSE_BILL_FAILURE';

export const FETCH_PENDING_BILL_CHALLANS_REQUEST = 'FETCH_PENDING_BILL_CHALLANS_REQUEST';
export const FETCH_PENDING_BILL_CHALLANS_SUCCESS = 'FETCH_PENDING_BILL_CHALLANS_SUCCESS';
export const FETCH_PENDING_BILL_CHALLANS_FAILURE = 'FETCH_PENDING_BILL_CHALLANS_FAILURE';

export const FETCH_PO_BILL_SUMMARY_REQUEST = 'FETCH_PO_BILL_SUMMARY_REQUEST';
export const FETCH_PO_BILL_SUMMARY_SUCCESS = 'FETCH_PO_BILL_SUMMARY_SUCCESS';
export const FETCH_PO_BILL_SUMMARY_FAILURE = 'FETCH_PO_BILL_SUMMARY_FAILURE';

export const FETCH_PO_RECONCILIATION_REQUEST = 'FETCH_PO_RECONCILIATION_REQUEST';
export const FETCH_PO_RECONCILIATION_SUCCESS = 'FETCH_PO_RECONCILIATION_SUCCESS';
export const FETCH_PO_RECONCILIATION_FAILURE = 'FETCH_PO_RECONCILIATION_FAILURE';

export const FETCH_BILL_STATISTICS_REQUEST = 'FETCH_BILL_STATISTICS_REQUEST';
export const FETCH_BILL_STATISTICS_SUCCESS = 'FETCH_BILL_STATISTICS_SUCCESS';
export const FETCH_BILL_STATISTICS_FAILURE = 'FETCH_BILL_STATISTICS_FAILURE';

export const SET_BILL_FILTERS = 'SET_BILL_FILTERS';
export const CLEAR_BILL_FILTERS = 'CLEAR_BILL_FILTERS';
export const CLEAR_CURRENT_BILL = 'CLEAR_CURRENT_BILL';
export const CLEAR_BILL_ERROR = 'CLEAR_BILL_ERROR';

// Intelligence Types
export const FETCH_BILL_ANOMALIES_REQUEST = 'FETCH_BILL_ANOMALIES_REQUEST';
export const FETCH_BILL_ANOMALIES_SUCCESS = 'FETCH_BILL_ANOMALIES_SUCCESS';
export const FETCH_BILL_ANOMALIES_FAILURE = 'FETCH_BILL_ANOMALIES_FAILURE';

export const FETCH_PO_SAVINGS_REQUEST = 'FETCH_PO_SAVINGS_REQUEST';
export const FETCH_PO_SAVINGS_SUCCESS = 'FETCH_PO_SAVINGS_SUCCESS';
export const FETCH_PO_SAVINGS_FAILURE = 'FETCH_PO_SAVINGS_FAILURE';

export const FETCH_MONTH_COMPARISON_REQUEST = 'FETCH_MONTH_COMPARISON_REQUEST';
export const FETCH_MONTH_COMPARISON_SUCCESS = 'FETCH_MONTH_COMPARISON_SUCCESS';
export const FETCH_MONTH_COMPARISON_FAILURE = 'FETCH_MONTH_COMPARISON_FAILURE';

// Recurring PO Types
export const CREATE_RECURRING_PO_REQUEST = 'CREATE_RECURRING_PO_REQUEST';
export const CREATE_RECURRING_PO_SUCCESS = 'CREATE_RECURRING_PO_SUCCESS';
export const CREATE_RECURRING_PO_FAILURE = 'CREATE_RECURRING_PO_FAILURE';

export const FETCH_RECURRING_POS_REQUEST = 'FETCH_RECURRING_POS_REQUEST';
export const FETCH_RECURRING_POS_SUCCESS = 'FETCH_RECURRING_POS_SUCCESS';
export const FETCH_RECURRING_POS_FAILURE = 'FETCH_RECURRING_POS_FAILURE';

export const UPDATE_RECURRING_PO_REQUEST = 'UPDATE_RECURRING_PO_REQUEST';
export const UPDATE_RECURRING_PO_SUCCESS = 'UPDATE_RECURRING_PO_SUCCESS';
export const UPDATE_RECURRING_PO_FAILURE = 'UPDATE_RECURRING_PO_FAILURE';

// PO Pending Approval (from create response)
export const PO_PENDING_APPROVAL = 'PO_PENDING_APPROVAL';
export const CLEAR_PO_PENDING_APPROVAL = 'CLEAR_PO_PENDING_APPROVAL';

// Return Order Types
export const CREATE_RETURN_ORDER_REQUEST = 'CREATE_RETURN_ORDER_REQUEST';
export const CREATE_RETURN_ORDER_SUCCESS = 'CREATE_RETURN_ORDER_SUCCESS';
export const CREATE_RETURN_ORDER_FAILURE = 'CREATE_RETURN_ORDER_FAILURE';

export const FETCH_RETURN_ORDERS_REQUEST = 'FETCH_RETURN_ORDERS_REQUEST';
export const FETCH_RETURN_ORDERS_SUCCESS = 'FETCH_RETURN_ORDERS_SUCCESS';
export const FETCH_RETURN_ORDERS_FAILURE = 'FETCH_RETURN_ORDERS_FAILURE';

export const FETCH_RETURN_ORDER_REQUEST = 'FETCH_RETURN_ORDER_REQUEST';
export const FETCH_RETURN_ORDER_SUCCESS = 'FETCH_RETURN_ORDER_SUCCESS';
export const FETCH_RETURN_ORDER_FAILURE = 'FETCH_RETURN_ORDER_FAILURE';

export const APPROVE_RETURN_ORDER_REQUEST = 'APPROVE_RETURN_ORDER_REQUEST';
export const APPROVE_RETURN_ORDER_SUCCESS = 'APPROVE_RETURN_ORDER_SUCCESS';
export const APPROVE_RETURN_ORDER_FAILURE = 'APPROVE_RETURN_ORDER_FAILURE';

export const UPDATE_RETURN_ORDER_STATUS_REQUEST = 'UPDATE_RETURN_ORDER_STATUS_REQUEST';
export const UPDATE_RETURN_ORDER_STATUS_SUCCESS = 'UPDATE_RETURN_ORDER_STATUS_SUCCESS';
export const UPDATE_RETURN_ORDER_STATUS_FAILURE = 'UPDATE_RETURN_ORDER_STATUS_FAILURE';

// Credit Note Types
export const CREATE_CREDIT_NOTE_REQUEST = 'CREATE_CREDIT_NOTE_REQUEST';
export const CREATE_CREDIT_NOTE_SUCCESS = 'CREATE_CREDIT_NOTE_SUCCESS';
export const CREATE_CREDIT_NOTE_FAILURE = 'CREATE_CREDIT_NOTE_FAILURE';

export const FETCH_CREDIT_NOTES_REQUEST = 'FETCH_CREDIT_NOTES_REQUEST';
export const FETCH_CREDIT_NOTES_SUCCESS = 'FETCH_CREDIT_NOTES_SUCCESS';
export const FETCH_CREDIT_NOTES_FAILURE = 'FETCH_CREDIT_NOTES_FAILURE';

export const FETCH_CREDIT_NOTE_REQUEST = 'FETCH_CREDIT_NOTE_REQUEST';
export const FETCH_CREDIT_NOTE_SUCCESS = 'FETCH_CREDIT_NOTE_SUCCESS';
export const FETCH_CREDIT_NOTE_FAILURE = 'FETCH_CREDIT_NOTE_FAILURE';

export const ADJUST_CREDIT_NOTE_REQUEST = 'ADJUST_CREDIT_NOTE_REQUEST';
export const ADJUST_CREDIT_NOTE_SUCCESS = 'ADJUST_CREDIT_NOTE_SUCCESS';
export const ADJUST_CREDIT_NOTE_FAILURE = 'ADJUST_CREDIT_NOTE_FAILURE';

export const CLEAR_RETURN_ERROR = 'CLEAR_RETURN_ERROR';

// Quotation Types
export const CREATE_QUOTATION_REQUEST = 'CREATE_QUOTATION_REQUEST';
export const CREATE_QUOTATION_SUCCESS = 'CREATE_QUOTATION_SUCCESS';
export const CREATE_QUOTATION_FAILURE = 'CREATE_QUOTATION_FAILURE';

export const FETCH_QUOTATIONS_REQUEST = 'FETCH_QUOTATIONS_REQUEST';
export const FETCH_QUOTATIONS_SUCCESS = 'FETCH_QUOTATIONS_SUCCESS';
export const FETCH_QUOTATIONS_FAILURE = 'FETCH_QUOTATIONS_FAILURE';

export const FETCH_QUOTATION_REQUEST = 'FETCH_QUOTATION_REQUEST';
export const FETCH_QUOTATION_SUCCESS = 'FETCH_QUOTATION_SUCCESS';
export const FETCH_QUOTATION_FAILURE = 'FETCH_QUOTATION_FAILURE';

export const UPDATE_QUOTATION_STATUS_REQUEST = 'UPDATE_QUOTATION_STATUS_REQUEST';
export const UPDATE_QUOTATION_STATUS_SUCCESS = 'UPDATE_QUOTATION_STATUS_SUCCESS';
export const UPDATE_QUOTATION_STATUS_FAILURE = 'UPDATE_QUOTATION_STATUS_FAILURE';

export const CONVERT_QUOTATION_REQUEST = 'CONVERT_QUOTATION_REQUEST';
export const CONVERT_QUOTATION_SUCCESS = 'CONVERT_QUOTATION_SUCCESS';
export const CONVERT_QUOTATION_FAILURE = 'CONVERT_QUOTATION_FAILURE';

export const FETCH_COMPARATIVE_STATEMENT_REQUEST = 'FETCH_COMPARATIVE_STATEMENT_REQUEST';
export const FETCH_COMPARATIVE_STATEMENT_SUCCESS = 'FETCH_COMPARATIVE_STATEMENT_SUCCESS';
export const FETCH_COMPARATIVE_STATEMENT_FAILURE = 'FETCH_COMPARATIVE_STATEMENT_FAILURE';

export const CLEAR_QUOTATION_ERROR = 'CLEAR_QUOTATION_ERROR';

// Price History Types
export const FETCH_PRODUCT_PRICE_HISTORY_REQUEST = 'FETCH_PRODUCT_PRICE_HISTORY_REQUEST';
export const FETCH_PRODUCT_PRICE_HISTORY_SUCCESS = 'FETCH_PRODUCT_PRICE_HISTORY_SUCCESS';
export const FETCH_PRODUCT_PRICE_HISTORY_FAILURE = 'FETCH_PRODUCT_PRICE_HISTORY_FAILURE';

export const FETCH_VENDOR_PRICE_HISTORY_REQUEST = 'FETCH_VENDOR_PRICE_HISTORY_REQUEST';
export const FETCH_VENDOR_PRICE_HISTORY_SUCCESS = 'FETCH_VENDOR_PRICE_HISTORY_SUCCESS';
export const FETCH_VENDOR_PRICE_HISTORY_FAILURE = 'FETCH_VENDOR_PRICE_HISTORY_FAILURE';

export const FETCH_PRICE_INFLATION_REQUEST = 'FETCH_PRICE_INFLATION_REQUEST';
export const FETCH_PRICE_INFLATION_SUCCESS = 'FETCH_PRICE_INFLATION_SUCCESS';
export const FETCH_PRICE_INFLATION_FAILURE = 'FETCH_PRICE_INFLATION_FAILURE';

// Approval Types
export const FETCH_APPROVAL_CONFIG_REQUEST = 'FETCH_APPROVAL_CONFIG_REQUEST';
export const FETCH_APPROVAL_CONFIG_SUCCESS = 'FETCH_APPROVAL_CONFIG_SUCCESS';
export const FETCH_APPROVAL_CONFIG_FAILURE = 'FETCH_APPROVAL_CONFIG_FAILURE';

export const UPDATE_APPROVAL_CONFIG_REQUEST = 'UPDATE_APPROVAL_CONFIG_REQUEST';
export const UPDATE_APPROVAL_CONFIG_SUCCESS = 'UPDATE_APPROVAL_CONFIG_SUCCESS';
export const UPDATE_APPROVAL_CONFIG_FAILURE = 'UPDATE_APPROVAL_CONFIG_FAILURE';

export const FETCH_PENDING_APPROVALS_REQUEST = 'FETCH_PENDING_APPROVALS_REQUEST';
export const FETCH_PENDING_APPROVALS_SUCCESS = 'FETCH_PENDING_APPROVALS_SUCCESS';
export const FETCH_PENDING_APPROVALS_FAILURE = 'FETCH_PENDING_APPROVALS_FAILURE';

export const FETCH_PO_APPROVAL_STATUS_REQUEST = 'FETCH_PO_APPROVAL_STATUS_REQUEST';
export const FETCH_PO_APPROVAL_STATUS_SUCCESS = 'FETCH_PO_APPROVAL_STATUS_SUCCESS';
export const FETCH_PO_APPROVAL_STATUS_FAILURE = 'FETCH_PO_APPROVAL_STATUS_FAILURE';

export const APPROVE_PO_REQUEST = 'APPROVE_PO_REQUEST';
export const APPROVE_PO_SUCCESS = 'APPROVE_PO_SUCCESS';
export const APPROVE_PO_FAILURE = 'APPROVE_PO_FAILURE';

export const REJECT_PO_APPROVAL_REQUEST = 'REJECT_PO_APPROVAL_REQUEST';
export const REJECT_PO_APPROVAL_SUCCESS = 'REJECT_PO_APPROVAL_SUCCESS';
export const REJECT_PO_APPROVAL_FAILURE = 'REJECT_PO_APPROVAL_FAILURE';

export const CLEAR_APPROVAL_ERROR = 'CLEAR_APPROVAL_ERROR';

// Vendor Performance Types
export const FETCH_VENDOR_PERFORMANCE_REQUEST = 'FETCH_VENDOR_PERFORMANCE_REQUEST';
export const FETCH_VENDOR_PERFORMANCE_SUCCESS = 'FETCH_VENDOR_PERFORMANCE_SUCCESS';
export const FETCH_VENDOR_PERFORMANCE_FAILURE = 'FETCH_VENDOR_PERFORMANCE_FAILURE';

export const FETCH_ALL_VENDOR_PERFORMANCE_REQUEST = 'FETCH_ALL_VENDOR_PERFORMANCE_REQUEST';
export const FETCH_ALL_VENDOR_PERFORMANCE_SUCCESS = 'FETCH_ALL_VENDOR_PERFORMANCE_SUCCESS';
export const FETCH_ALL_VENDOR_PERFORMANCE_FAILURE = 'FETCH_ALL_VENDOR_PERFORMANCE_FAILURE';

// Payment Types
export const CREATE_PAYMENT_REQUEST = 'CREATE_PAYMENT_REQUEST';
export const CREATE_PAYMENT_SUCCESS = 'CREATE_PAYMENT_SUCCESS';
export const CREATE_PAYMENT_FAILURE = 'CREATE_PAYMENT_FAILURE';

export const FETCH_BILL_PAYMENTS_REQUEST = 'FETCH_BILL_PAYMENTS_REQUEST';
export const FETCH_BILL_PAYMENTS_SUCCESS = 'FETCH_BILL_PAYMENTS_SUCCESS';
export const FETCH_BILL_PAYMENTS_FAILURE = 'FETCH_BILL_PAYMENTS_FAILURE';

export const FETCH_BILL_PAYMENT_SUMMARY_REQUEST = 'FETCH_BILL_PAYMENT_SUMMARY_REQUEST';
export const FETCH_BILL_PAYMENT_SUMMARY_SUCCESS = 'FETCH_BILL_PAYMENT_SUMMARY_SUCCESS';
export const FETCH_BILL_PAYMENT_SUMMARY_FAILURE = 'FETCH_BILL_PAYMENT_SUMMARY_FAILURE';

export const FETCH_ALL_PAYMENTS_REQUEST = 'FETCH_ALL_PAYMENTS_REQUEST';
export const FETCH_ALL_PAYMENTS_SUCCESS = 'FETCH_ALL_PAYMENTS_SUCCESS';
export const FETCH_ALL_PAYMENTS_FAILURE = 'FETCH_ALL_PAYMENTS_FAILURE';

export const FETCH_PAYMENT_STATISTICS_REQUEST = 'FETCH_PAYMENT_STATISTICS_REQUEST';
export const FETCH_PAYMENT_STATISTICS_SUCCESS = 'FETCH_PAYMENT_STATISTICS_SUCCESS';
export const FETCH_PAYMENT_STATISTICS_FAILURE = 'FETCH_PAYMENT_STATISTICS_FAILURE';

export const CLEAR_PAYMENT_ERROR = 'CLEAR_PAYMENT_ERROR';

// Analytics Types
export const FETCH_ANALYTICS_DASHBOARD_REQUEST = 'FETCH_ANALYTICS_DASHBOARD_REQUEST';
export const FETCH_ANALYTICS_DASHBOARD_SUCCESS = 'FETCH_ANALYTICS_DASHBOARD_SUCCESS';
export const FETCH_ANALYTICS_DASHBOARD_FAILURE = 'FETCH_ANALYTICS_DASHBOARD_FAILURE';

export const FETCH_ANALYTICS_VENDOR_PRODUCTS_REQUEST = 'FETCH_ANALYTICS_VENDOR_PRODUCTS_REQUEST';
export const FETCH_ANALYTICS_VENDOR_PRODUCTS_SUCCESS = 'FETCH_ANALYTICS_VENDOR_PRODUCTS_SUCCESS';
export const FETCH_ANALYTICS_VENDOR_PRODUCTS_FAILURE = 'FETCH_ANALYTICS_VENDOR_PRODUCTS_FAILURE';

export const SET_ANALYTICS_FILTERS = 'SET_ANALYTICS_FILTERS';
